import React from 'react';

interface Props {
  rating: number;
  size?: 'sm' | 'md' | 'lg';
}

const StarRating: React.FC<Props> = ({ rating, size = 'md' }) => {
  const percentage = (rating / 5) * 100;
  const sizes = { sm: '14px', md: '18px', lg: '24px' };
  const fontSize = sizes[size];
  
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      <div style={{ position: 'relative', display: 'inline-block', fontSize, letterSpacing: '2px' }}>
        <span style={{ color: '#ddd' }}>{'★★★★★'}</span>
        <span style={{
          position: 'absolute', top: 0, left: 0,
          overflow: 'hidden', width: `${percentage}%`,
          color: '#f5a623', whiteSpace: 'nowrap'
        }}>{'★★★★★'}</span>
      </div>
      <span style={{ fontSize: size === 'sm' ? '12px' : '14px', color: '#555', marginLeft: '4px' }}>
        {rating > 0 ? rating.toFixed(1) : 'No rating'}
      </span>
    </div>
  );
};

export default StarRating;
